module.exports = __webpack_public_path__ + "img/fullarm(bent90°)length.e43c1c49.jpeg";